import React from 'react';

import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { Button as AntButton } from 'antd';

import Button from './Button';
import styles from './FilterContainer.module.scss';

const { Group: ButtonGroup } = Button;

const FilterContainer = ({ children, loading, onClearClick }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {children}
            </div>

            <ButtonGroup className={styles.buttonGroup}>
                <Button
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    loading={loading}
                    title="Buscar"
                    borderRadius={null}
                />
                {onClearClick ? (
                    <AntButton
                        htmlType="button"
                        icon={<CloseOutlined />}
                        disabled={loading}
                        onClick={onClearClick}
                        title="Limpar filtros"
                        danger
                        size="large"
                    />
                ) : null}
            </ButtonGroup>
        </div>
    );
};

export default FilterContainer;
